const axios = require("axios");

const singleton = Symbol();
const singletonEnforcer = Symbol();

class API {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error("Cannot construct singleton");
    }

    this.session = axios.create({
      headers: {
        "X-Requested-With": "FLOTEK-DOG",
      },
    });
  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new API(singletonEnforcer);
    }

    return this[singleton];
  }
  get = (...params) => this.session.get(...params);
  post = (...params) => this.session.post(...params);
  put = (...params) => this.session.put(...params);
  patch = (...params) => this.session.patch(...params);
  remove = (...params) => this.session.delete(...params);
}

export default API.instance;
